import { ref } from 'vue'
import localCache from '@/utils/cache'

/** 标签页共享状态（独立文件，避免 store 与 hook 循环依赖） */
export const tabList = ref<any[]>([])
export const activeTab = ref('')
export let tabListInitialized = false

export function markTabListInitialized() {
  tabListInitialized = true
}

export function resetTabList() {
  tabList.value = []
  activeTab.value = ''
  tabListInitialized = false
  localCache.deleteCache('tabList')
}
